<template>
  <div
    class="tw-bg-sf-snow-lighter"
    :class="[
      'inbox-check-card',
      { 'sf-commcard-user-can-check': currentUserCanCheck },
      checkStateClass,
    ]"
  >
    <div class="sf-pad-h-3 sf-pad-t-3 sf-full-width">
      <div class="sf-level sf-level-between">
        <div class="sf-level">
          <div class="sf-label sf-label-rectangular ledger-period-name">
            {{ ledgerPeriodName }}
          </div>

          <div>
            <a
              class="sf-a sf-pointer sf-c-primary sf-font-medium"
              :href="checkListUrl"
              @click="trackClick('checklist-name')"
            >
              {{ checkListTitle }}
            </a>
            <span class="sf-c-primary">•</span>
            <a
              class="sf-a sf-pointer sf-c-primary sf-font-medium"
              :href="contextUrl"
              @click="trackClick('context-name')"
            >
              {{ contextName }}
            </a>
          </div>
        </div>
        <div>
          <a
            class="sf-btn sf-level"
            :href="contextUrl"
            @click="trackClick('context-button')"
          >
            <span>{{ I18n.t('communication.cards.caption_btn.context') }}</span>
          </a>
        </div>
      </div>
    </div>
    <div class="sf-commcard-message">
      <div class="sf-commcard-message-content">
        <div class="sf-commcard-message-content-toggle">
          <div
            v-tooltip.html="tooltipHtmlContent"
            class="sf-form-check-indicator"
            :class="[currentUserCanCheck ? 'sf-pointer' : 'user-cant-check']"
            @click.prevent="currentUserCanCheck ? handleCheckClick() : null"
          />
        </div>

        <div class="sf-commcard-message-content-post sf-commcard-post">
          <div v-dompurify-html="renderedText" class="sf-commcard-post-text" />
        </div>
      </div>
    </div>

    <div class="sf-commcard-comments sf-bg-white sf-pad-h-3">
      <comment-card
        v-for="comment in allComments"
        v-bind="comment"
        :key="comment.id"
        :commentable-id="id"
        commentable-type="CheckLink"
      />
    </div>

    <comment-form
      text=""
      btn-text="Reply"
      :follower-ids="followerIds"
      :commentable-id="id"
      commentable-type="CheckLink"
      :focus-form="false"
      :placeholder="I18n.t('communication.comments.enter_reply')"
    />
  </div>
</template>

<script>
import trackEvent from '@app/utils/track_event'

import CheckCard from '@app/application/communication/sections/communication/components/checks/check-card'

export default {
  extends: CheckCard,

  props: {
    checkListTitle: {
      type: String,
      required: true,
    },
    checkListUrl: {
      type: String,
      required: true,
    },
  },

  computed: {
    itemUrl() {
      const url = new URL(this.context.url, window.location.origin)
      url.searchParams.append('current_ledger_id', this.ledgerId)
      return url.toString()
    },

    contextUrl() {
      const context = this.context
      const wfReviewUrl = context.workflowReviewUrl

      if (wfReviewUrl) {
        return wfReviewUrl
      }

      const itemUrl = new URL(this.itemUrl)
      if (this.isCompanyContext) {
        itemUrl.hash = `check-link-${this.id}`
      } else {
        itemUrl.searchParams.append('anchor', `check-link-${this.id}`)
      }
      return itemUrl
    },

    contextName() {
      return this.context.name
    },

    context() {
      return this.contextByLedgerTypeAndId(
        this.ledgerId,
        this.contextType,
        this.contextId
      )
    },
  },

  methods: {
    trackClick(label) {
      trackEvent('inbox', 'click', label)
    },
  },
}
</script>

<style>
.inbox-check-card .sf-commcard-reply-form-footer {
  background: white;
}

.inbox-check-card .sf-commcard-message-content {
  padding-bottom: 0;
}

.inbox-check-card .sf-commcard-post:last-child {
  border-bottom: 0;
}

.inbox-check-card .sf-commcard-comments .sf-commcard-post-text {
  font-size: 13px;
}

.inbox-check-card .sf-commcard-reply-form-files {
  background: none;
}

.inbox-check-card .sf-commcard-comments .sf-commcard-post {
  padding-left: 0;
  padding-right: 0;
}

.inbox-check-card .sf-form-check-indicator.user-cant-check {
  box-shadow: inset 0 0 0 1px #e6e7e8, inset 0 0 0 4px #f2f2f2;
  background-color: #f2f2f2;
  cursor: not-allowed !important;
}

.ledger-period-name {
  white-space: nowrap;
}
</style>
